import { Component, inject, InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MessageLevel, UserInfoDialogData } from 'src/app/interfaces/dialog.interface';
import { NotificationState } from '../../notifications.state';
import { DialogActionTypes } from '../dialogs.enum';

export const USER_INFO_DIALOG_DATA = new InjectionToken<UserInfoDialogData>(`USER_INFO_DIALOG_DATA`);
@Component({
  selector: 'app-dialog-user-info',
  templateUrl: './dialog-user-info.component.html',
  styleUrls: ['./dialog-user-info.component.scss'],
})
export class DialogUserInfoComponent extends NotificationState {
  public readonly dislog = inject(USER_INFO_DIALOG_DATA);
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);

  protected notificationLevel: MessageLevel = 'INFO';

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(): void {
    //Simply ignore
  }
}
